import { render, staticRenderFns } from "./Datatable_pagination.vue?vue&type=template&id=92d7de4e&scoped=true"
import script from "./Datatable_pagination.vue?vue&type=script&lang=js"
export * from "./Datatable_pagination.vue?vue&type=script&lang=js"
import style0 from "./Datatable_pagination.vue?vue&type=style&index=0&id=92d7de4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d7de4e",
  null
  
)

export default component.exports